/** ------------------------------------------------------
 Scheduled Popups
 --------------------------------------------------------*/

class _scheduledPopups {

    init = () => {

        this.scheduledPopup = document.getElementById('scheduledPopup');

        if( this.scheduledPopup ) {
            this.popupContent = this.scheduledPopup.querySelector('.popup-content');
            this.popupNotification = this.scheduledPopup.querySelector('.popup-notification');
            this.btnShowPopupContent =  this.scheduledPopup.querySelector('.btn-show-popup-content');
            this.btnHidePopupContent = this.scheduledPopup.querySelector('.btn-hide-popup-content');

            this.conditionDelay = false;
            this.conditionScroll = false;

            this.defaultCookieValueObj = {
                userVisits: 0,
                mostRecentDismiss: 0,
                dismissedPopups: {}
            }

            this.updateUserVisitsCookieData();
            this.clearExpiredDismissedCookies();
            this.setDelayCondition();
            this.setScrollCondition();
            this.listenForEvents();
        }
    }

    listenForEvents = () => {
        if(this.btnShowPopupContent) {
            this.btnShowPopupContent.addEventListener("click", this.showPopupContent);
        }

        this.btnHidePopupContent.addEventListener("click", this.dismissPopup);
    }

    maybeShowPopup = () => {
        if(!this.popupNotification) {
            if( this.conditionDelay && this.conditionScroll ){
                this.slideDown(this.popupContent,300);
            }
        } else {
            if( this.conditionDelay && this.conditionScroll ){
                this.slideDown(this.popupNotification,300);
            }
        }

    }

    showPopupContent = () => {
        if(this.popupNotification) {
            this.slideUp(this.popupNotification,300);
        }

        this.slideDown(this.popupContent,300);

        if( window.innerWidth < 650) {
            this.lockBodyScroll();
        }
    }

    hidePopupContent = () => {
        if(this.popupNotification) {
            this.slideUp(this.popupNotification,300);
        }

        this.slideDown(this.popupContent,300);

        if( window.innerWidth < 650) {
            this.unlockBodyScroll();
        }
    }

    dismissPopup = () => {
        if(this.popupNotification) {
            this.slideUp(this.popupNotification,300);
        }

        this.slideUp(this.popupContent,300);
        this.updatePopupViewedCookieData();

        if( window.innerWidth < 650) {
            this.unlockBodyScroll();
        }
    }

    updatePopupViewedCookieData = () => {
        let popupID = this.scheduledPopup.getAttribute('data-popup-id');
        let dismissedExpiration = parseInt( this.scheduledPopup.getAttribute('data-popup-expiration') );
        let cookie = this.getCookie( scheduled_popup_obj.cookieID );

        let timestamp = Math.round(new Date() / 1000);
        let valueObj;

        if( cookie ){
            valueObj = JSON.parse( cookie ) ;
            valueObj.mostRecentDismiss = timestamp;
            valueObj.dismissedPopups[popupID] = timestamp + ( dismissedExpiration * 24 * 60 * 60 );
            this.setCookie( scheduled_popup_obj.cookieID, JSON.stringify( valueObj ), scheduled_popup_obj.cookieExpirationDays );

        }else{
            valueObj = this.defaultCookieValueObj;
            valueObj.mostRecentDismiss = timestamp;
            valueObj.dismissedPopups[popupID] = timestamp + ( dismissedExpiration * 24 * 60 * 60 );
            this.setCookie( scheduled_popup_obj.cookieID, JSON.stringify( valueObj ), scheduled_popup_obj.cookieExpirationDays );
        }
    }

    updateUserVisitsCookieData = () => {
        let cookie = this.getCookie( scheduled_popup_obj.cookieID );
        let valueObj;

        if( cookie ){
            valueObj = JSON.parse( cookie ) ;
            valueObj.userVisits++;
            this.setCookie( scheduled_popup_obj.cookieID, JSON.stringify( valueObj ), scheduled_popup_obj.cookieExpirationDays );
        }else{
            valueObj = this.defaultCookieValueObj;
            valueObj.userVisits = 1;
            this.setCookie( scheduled_popup_obj.cookieID, JSON.stringify( valueObj ), scheduled_popup_obj.cookieExpirationDays );
        }
    }

    clearExpiredDismissedCookies = () => {
        let cookie = this.getCookie( scheduled_popup_obj.cookieID );
        let timestamp = Math.round(new Date() / 1000);

        if( cookie ){
            let valueObj = JSON.parse( cookie ) ;

            if( valueObj.hasOwnProperty('dismissedPopups') &&
                (Object.keys(valueObj.dismissedPopups).length !== 0) &&
                (valueObj.dismissedPopups.constructor === Object)
            ){
                Object.keys(valueObj.dismissedPopups).forEach( function( key, expiration ) {
                    if ( expiration < timestamp ){
                        delete valueObj.dismissedPopups[key];
                    }
                });
            }

            this.setCookie( scheduled_popup_obj.cookieID, JSON.stringify( valueObj ), scheduled_popup_obj.cookieExpirationDays );
        }
    }

    setDelayCondition = () => {
        let delay = parseInt( this.scheduledPopup.getAttribute('data-delay') );

        if( delay > 0 ){
            const self = this;
            document.addEventListener("DOMContentLoaded", function(){
                setTimeout( function(){
                    self.conditionDelay = true;
                    self.maybeShowPopup();
                }, delay * 1000);
            });
        }else{
            this.conditionDelay = true;
            this.maybeShowPopup();
        }
    }

    setScrollCondition = () => {
        const self = this;
        let scrollTrigger = parseInt( this.scheduledPopup.getAttribute('data-scroll-position') );

        if( scrollTrigger > 0 ){

            self.checkScrollCondition(scrollTrigger);
            window.addEventListener("scroll", function(){
                self.checkScrollCondition(scrollTrigger);
            } );

        }else{

            this.conditionScroll = true;
            this.maybeShowPopup();

        }
    }

    checkScrollCondition = (scrollTrigger) => {

        if( this.conditionScroll ){ return; }

        let wintop = window.pageYOffset;
        let docheight = document.body.clientHeight;
        let winheight = window.innerHeight;
        let scrollPercentage = wintop / (docheight-winheight) * 100;

        if( scrollPercentage >= scrollTrigger ){
            this.conditionScroll = true;
            this.maybeShowPopup();
        }
    }

    lockBodyScroll = () => {
        document.querySelector('body').classList.add('lock-body');
    }

    unlockBodyScroll = () => {
        document.querySelector('body').classList.remove('lock-body');
    }

    slideUp = (target, duration) => {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.style.overflow = 'hidden';

        window.setTimeout( () => {
            target.style.visibility = 'hidden';
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideDown = (target, duration) => {

        let height = target.offsetHeight;
        let bottom = window.getComputedStyle(target).bottom;

        target.style.bottom = (0 - height) + 'px';

        target.style.removeProperty('visibility');
        let visibility = window.getComputedStyle(target).visibility;
        if (visibility === 'hidden') {
            visibility = 'visible';
        }

        target.style.visibility = visibility;
        target.style.transitionProperty = "bottom";
        target.style.transitionDuration = duration + 'ms';
        target.style.bottom = bottom;
        //target.style.height = height;

        window.setTimeout( () => {
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    getCookie = (name) => {
        let keyValue = document.cookie.match('(^|;) ?' + encodeURIComponent(name) + '=([^;]*)(;|$)');
        return keyValue ? decodeURIComponent( keyValue[2] ) : null;
    }

    setCookie = (name, value, days) => {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        let expires = "; expires=" + date.getTime();
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }
}

new _scheduledPopups().init();







